import { render } from "./Assignments.vue?vue&type=template&id=7699dd98&scoped=true"
import script from "./Assignments.vue?vue&type=script&lang=ts"
export * from "./Assignments.vue?vue&type=script&lang=ts"

import "./Assignments.vue?vue&type=style&index=0&id=7699dd98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7699dd98"

export default script